import * as React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

import '../CSS/loading.css'
export const Loading = ({size}) => (
  <div className="loading-shading-mui">
    <CircularProgress size={size} color='primary' variant="indeterminate" disableShrink={true} thickness={2.5}className="loading-icon-mui" />
  </div>
);
